<template>
  <div :class="['list-item-wrapper', scope]" @mouseenter="toExpand" @mouseleave="doRestore">
    <div class="list-item">
      <div class="item-top">
      <div class="item-tags" v-if="colorItem.brands_logo || colorItem.designer_logo || data.product_label || data.custom_tags">
        <img class="logo" v-if="colorItem.brands_logo" :src="colorItem.brands_logo">
        <img class="logo designer-logo" v-if="colorItem.designer_logo" :src="colorItem.designer_logo">
        <div class="item-tag" v-if="data.product_label && typeof data.product_label === 'string'">
          {{ data.product_label }}
        </div>
        <template class="item-tag" v-else-if="Array.isArray(data.product_label)">
          <div v-for="(label, index) in data.product_label" :key="index" class="item-tag">
            {{ label }}
          </div>
        </template>
        <template class="item-tag" v-if="Array.isArray(data.custom_tags) && calcIsShowCustomerTag && data.custom_tags">
          <div v-for="(label, index) in data.custom_tags" :key="'custom' + index" class="item-tag custom-tags">
            {{ label }}
          </div>
        </template>
      </div>
      <div class="item-image" @mouseenter="toViewFRImg" @mouseleave="doResetFRImg">
        <router-link :to="`/detail/${data.id}-${data.color}`">
          <img :src="viewImg" />
        </router-link>
      </div>
    </div>
    <div class="item-bottom">
      <div v-if="scope == 'list'" class="item-swatches">
        <div class="item-swatches-wrapper">
          <div class="item-swatches-items">
            <template v-if="data.colors && data.colors.length > 3">
              <!-- <i :class="['iconfont', xSwiper && xSwiper.isBeginning ? 'disabled' : 'enabled']" @click="goColor(-1)">&#xe615;</i> -->
              <swiper class="item-colors" :options="swiperOption" ref="xSwiper">
                <swiperSlide class="item-colors-swatch" v-for="(color, colorIndex) in data.colors" :key="colorIndex">
                  <router-link class="color-image" :to="`/detail/${data.id}-${color.id}`">
                    <img :src="color.cover" @mouseenter="setViewImg(color)" @mouseleave="resetViewImg" :alt="color.name" :title="color.name" />
                  </router-link>
                </swiperSlide>
                <i class="iconfont icon-left-arrow" slot="button-prev">&#xe615;</i>
                <i class="iconfont icon-right-arrow" slot="button-next">&#xe628;</i>
              </swiper>
              <!-- <i :class="['iconfont', xSwiper && xSwiper.isEnd ? 'disabled' : 'enabled']" @click="goColor(+1)">&#xe628;</i> -->
            </template>
            <template v-else>
              <div class="item-colors">
                <div class="item-colors-swatch" v-for="(color, colorIndex) in data.colors" :key="colorIndex">
                  <router-link class="color-image" :to="`/detail/${data.id}-${color.id}`">
                    <img :src="color.cover" @mouseenter="setViewImg(color)" @mouseleave="resetViewImg" :alt="color.name" :title="color.name" />
                  </router-link>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="item-name">
        <router-link :to="`/detail/${data.id}-${data.colors[0].id}`">{{ data.name }}</router-link>
      </div>
      <div class="item-classification">{{ data.gender.name }} / {{ data.category.name }}</div>
      <template v-if="isShowOriginalPrice(data)">
        <div class="item-pricing has-original_price">
          <span class="rmb-symbol">￥</span>{{ data.price }}
          <span class="item-original_price">
            <span class="rmb-symbol">￥{{ data.original_price }}</span>
          </span>
        </div>
      </template>
      <template v-else>
        <div class="item-pricing"><span class="rmb-symbol">￥</span>{{ data.price }}</div>
      </template>
      <button class="item-view" v-if="!isGoodsColorDisabled(data.id, data.color)"
        @click="toView(data.id, data.color || data.colors)">快速购买</button>
    </div>
    
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import utils from "@/utils";
import storeFunc from "@/utils/storeFunc";
export default {
  name: "ListItem",
  components: { swiper, swiperSlide },
  props: {
    data: {
      type: Object,
      required: true
    },
    // 用于区分不用作用域以便处理样式
    scope: {
      type: String,
      default: "list",
      validator(value) {
        // 列表项组件可用于“类目列表”、“相关推荐”、“最近浏览”中
        return ["list", "recommend", "history"].indexOf(value) != -1;
      }
    }
  },
  computed: {
    colorItem() {
      //当前查看颜色
      return this.data?.colors?.find(i => i.id === this.selectedColor) || {}
    },
    calcIsShowCustomerTag() {
      if (["history", "recommend"].includes(this.scope)) {
        return this.$store.state.isShowCustomerTag &&  this.$store.state.tagsConfig.show_page.includes(this.scope)
      }
      return this.$store.state.isShowCustomerTag;
    },
  },
  data() {
    return {
      viewImg: '',
      selectedColor: null,//当前查看颜色
      xSwiper: {},
      swiperOption: {
        slidesPerView: 3,
        navigation: {
          nextEl: '.icon-right-arrow',
          prevEl: '.icon-left-arrow'
        },
        on: {
          slideChangeTransitionEnd: () => {
            console.log(this?.xSwiper?.activeIndex);
          }
        }
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    isShowOriginalPrice: utils.isShowOriginalPrice,
    isGoodsColorDisabled: storeFunc.isGoodsColorDisabled,
    init() {
      this.resetViewImg();
    },
    toExpand(evt) {
      if (this.scope !== 'list') return false;
      if (window.innerWidth <= 1024) return false;
      let dom = evt.target || evt.srcElement;
      let oHeight = window.getComputedStyle(dom, null).height;
      if (dom.style.setProperty) {
        dom.style.setProperty('height', oHeight);
      } else {
        dom.style.height = oHeight;
      }
      if (dom.classList && dom.classList.add) {
        dom.classList.add('active');
      } else {
        dom.className = dom.className + ' active';
      }
    },
    doRestore(evt) {
      if (this.scope !== 'list') return false;
      if (window.innerWidth <= 1024) return false;
      let dom = evt.target || evt.srcElement;
      if (dom.classList && dom.classList.remove) {
        dom.classList.remove('active');
      } else {
        dom.className = dom.className.replace(/active/g, '').replace(/\s/g, ' ');
      }
      if (dom.style.removeProperty) {
        dom.style.removeProperty('height');
      } else {
        dom.style.height = '';
      }
    },
    // Set Front-Right view
    toViewFRImg() {
      this.viewImg = this.data?.hoverCover || this.data?.images?.[1];
    },
    // Reset Front-Right view
    doResetFRImg() {
      this.viewImg = this.data?.cover || this.data?.images?.[0];
    },
    // 设置颜色对应的图
    setViewImg(color) {
      this.viewImg = color?.cover;
      this.selectedColor = color?.id;
    },
    // 还原颜色对应的图
    resetViewImg() {
      this.viewImg = this.data?.cover || this.data?.images?.[0];
      this.selectedColor = this.data?.color || this.data?.colors?.[0]?.id;
    },
    goColor(offset) {
      if (offset == -1) {
        this.xSwiper.slidePrev();
      } else {
        this.xSwiper.slideNext();
      }
    },
    toView(id, color) {
      if (Array.isArray(color)) {
        this.$emit('itemview', { id, color: color?.[0]?.id });
      } else {
        this.$emit('itemview', { id, color });
      }
    }
  },
  watch: {
    'data'() {
      this.init();
      this.$nextTick(() => {
        this.xSwiper = this.$refs?.xSwiper?.swiper;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$item-width: 249px;

.list-item-wrapper {
  box-sizing: border-box;
  height: 100%;
  background: #fff;
  color: #999;
  padding-bottom: 20px;
  position: relative;
  text-align: center;
  display: flex;
  align-items: flex-end;
  .item-top{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .list-item {
    position: relative;
    background: #FFF;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .item-image {
      height: auto;

      a {
        img {
          width: $item-width;
          max-width: 100%;
          // height: 187px;
          height: auto;
          margin: auto;
        }
      }
    }

    .item-swatch-count {
      font-weight: 700;
      font-size: calc(0.75rem * 1.6);
      line-height: calc(1.375rem * 1.6);
      margin: 0;
      color: #666;
      text-transform: capitalize;
      width: 100%;
    }

    .item-swatches {
      min-height: 63px;
      margin-top: calc(.3125rem * 1.6);
      margin: 0 auto;
      position: relative;
      display: none;

      .item-swatches-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;

        .item-swatches-items {
          display: flex;
          align-items: center;
          width: 225px;

          .iconfont {
            font-weight: 400;
            cursor: pointer;

            &.disabled {
              color: #EFEFEF;
            }
          }

          .icon-left-arrow,
          .icon-right-arrow {
            font-size: 24px;
            position: absolute;
            top: 50%;
            z-index: 1;
            transform: translate(0, -50%);

            &.swiper-button-disabled {
              color: #efefef;
            }
          }

          .icon-left-arrow {
            left: 0;
          }

          .icon-right-arrow {
            right: 0;
          }

          .item-colors {
            width: 195px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 auto;

            // & ::v-deep .swiper-wrapper { align-items: center; }
            .item-colors-swatch {
              display: flex;
              justify-content: center;
              width: 65px;

              .color-image {
                font-weight: 400;
                display: block;
                width: 50px;
                border-bottom: 2px solid transparent;

                img {
                  width: 50px;
                  height: auto;
                }

                &:hover {
                  border-bottom: 2px solid #999;
                }
              }
            }
          }
        }
      }
    }

    .item-name {
      padding-left: 20px;
      padding-right: 20px;
      height: auto;
      line-height: calc(1rem * 1.6) !important;
      margin-bottom: 5px !important;

      a {
        font-weight: 700;
        font-size: calc(1rem * 1.6);
        margin: 0;
        line-height: calc(1.375rem * 1.6);
        color: #000;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .item-classification {
      font-size: calc(0.625rem * 1.6);
      font-weight: 600;
      color: #333;
      margin-bottom: 5px !important;
      line-height: calc(0.75rem * 1.6) !important;
      text-align: center !important;
    }

    .item-pricing {
      padding-left: 20px;
      padding-right: 20px;
      padding-bottom: 15px;
      line-height: calc(1.25rem * 1.6);
      font-weight: 400;
      font-size: calc(0.875rem * 1.6);
      color: #4d4d4c;

      &.has-original_price {
        color: #212322;
        font-weight: 700;

        .item-original_price {
          margin-left: 8px;
          color: #4d4d4c;
          font-weight: 400;
          text-decoration: line-through;
        }
      }
    }

    .item-view {
      font-weight: 400;
      font-size: calc(0.875rem * 1.6);
      color: #fff;
      position: absolute;
      bottom: 20px;
      display: none;
      left: 0;
      width: 95%;
      padding: 0.5em 0;
      margin: 0 2.5%;
      background-color: #7f0019;
      cursor: pointer;
    }
  }

  &.active {
    .list-item {
      position: absolute;
      left: -8px;
      top: -8px;
      height: auto;
      width: calc(100% + 16px);
      padding-bottom: 55px;
      padding-top: 8px;
      box-shadow: 0 0 9px 0 #ccc;
      z-index: 1;

      .item-swatch-count {
        display: none;
      }

      .item-swatches {
        display: block;
      }

      .item-view {
        display: block;
      }
    }
  }

  .item-tags {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: center;
    width: $item-width;
    max-width: 100%;
    box-sizing: border-box;
    margin: 0 auto;
    padding: 12px 10px 8px;
    gap: 8px;

    .logo {
      height: 24px;
      width: auto;

      &.designer-logo {
        height: 8px;
      }
    }

    .item-tag {
      color: #212322;
      /* 中文正文/Text-Small-12-R */
      font-family: Noto Sans CJK SC;
      font-size: 10px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      /* 150% */
      padding: 0 5px;
      border: 1px solid #212322;
      background: #fff;
    }
  }
}

@media only screen and (min-width: 1024px) {
  .list-item-wrapper {
    .list-item {
      .item-image {
        a {
          img {
            min-width: 210px;
            min-height: 210px;
          }
        }
      }
    }
  }
}
</style>
